import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { adminApi } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const saved = sessionStorage.getItem("admin_pwd");
    if (saved) navigate("/admin/dashboard", { replace: true });
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminApi(password).get("/admin/verify");
      sessionStorage.setItem("admin_pwd", password);
      toast.success("Welcome");
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error("Incorrect password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen flex items-center justify-center px-4 bg-slate-50">
      <form onSubmit={onSubmit} className="bg-white border border-slate-200 rounded-lg shadow-md p-8 w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-md bg-navy flex items-center justify-center">
            <Lock className="w-6 h-6 text-gold" />
          </div>
          <div>
            <h1 className="font-heading text-2xl font-bold text-navy">Admin Login</h1>
            <p className="text-sm text-gray-600">Alberta Traffic Tickets Defense</p>
          </div>
        </div>

        <label className="block mb-4">
          <span className="text-base font-semibold text-navy mb-1 block">Password</span>
          <input
            type="password"
            data-testid="admin-password-input"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full h-12 px-4 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy"
            placeholder="Enter admin password"
          />
        </label>

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-btn"
          className="btn-primary w-full disabled:opacity-60"
        >
          {loading ? <><Loader2 className="w-5 h-5 animate-spin" /> Verifying...</> : "Sign In"}
        </button>
      </form>
    </div>
  );
}
